import * as React from "react";
import { SecretCreateForm } from "./form";

export const SecretCreateInitializer: React.FC = () => {
  return <SecretCreateForm />;
};
